import { LazyImage } from "@/components/Helpers/LazyImage";
import { Link } from "gatsby";
import React from "react";
import * as styles from "./services.module.css";

interface ServiceCardProps {
  routerLink: string;
  title: string;
  description: string;
  icon: { file: { url: string } };
}

export const ServiceCard: React.FC<ServiceCardProps> = ({
  title,
  description,
  icon,
  routerLink,
}) => {
  return (
    <Link to={routerLink} style={{ textDecoration: "none", height: "100%", display: "block" }}>
      <div className={styles.serviceCard}>
        <div className={styles.iconContainer}>
          <LazyImage src={icon.file.url} alt={title} classNameExtra="m-0" />
        </div>
        <h3 className={styles.title}>{title}</h3>
        <p className={styles.description}>{description}</p>
        <div className={styles.ctaLink}>
          Learn More
          <span className={styles.ctaLinkIcon}>→</span>
        </div>
      </div>
    </Link>
  );
};
